import React, { useState, useContext } from "react";

// Section for Utilities and Context
import "./biobox.css";
import API from "../utils/API";
import { AuthContext } from "../utils/AuthContext";

// Default excerpt length shown before the reader has to expand the bio
const DEFAULT_BIO_LENGTH = 400;

export default function BioBox(props) {
    const { auth, isAdmin } = useContext(AuthContext);
    const [newBio, setNewBio] = useState(props.bio ?? "");
    const [bioEditing, setBioEditing] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const canEdit = isAdmin || auth.user.user_id === props.user_id || (auth.user.contributor && props.user_id === null);

    const submitUpdatedBio = async () => {
        try {
            const data = {
                profile_id: props.profile_id,
                user_bio: newBio
            }

            await API.updateBiography(data);
            setExpanded(false);
            props.reRenderProfile();
        } catch(error) {
           console.error("Server request failed: ",error);
        }
    };

    const handleEditBio = () => {
        setBioEditing(prevBioEditing => !prevBioEditing);

        if (bioEditing) {
            submitUpdatedBio();
        }
    };

    const bio = props.bio || "";
    const isLong = bio.length > DEFAULT_BIO_LENGTH;
    const displayText = expanded || !isLong ? bio : `${bio.slice(0, DEFAULT_BIO_LENGTH).trim()}…`;

    return (
        <>
            <div className="profile-overview-card-header">
                <span className="profile-overview-card-header-label">
                    <i className="bi bi-person-vcard" />
                    Bio
                </span>
                {canEdit && (
                    <i className={`bi bio-edit-icon ${bioEditing === false ? 'bi-pencil-square ' : 'bi-floppy2-fill'}`}
                        title={bioEditing ? "Save bio" : "Edit bio"}
                        onClick={() => handleEditBio()}
                    />
                )}
            </div>

            {!bioEditing ? (
                bio ? (
                    <p className="profile-overview-bio-excerpt mb-0">
                        {displayText}{' '}
                        {isLong && (
                            <span className="profile-overview-bio-link" onClick={() => setExpanded(prev => !prev)}>
                                {expanded ? 'Show less' : 'Show more'}
                            </span>
                        )}
                    </p>
                ) : (
                    <p className="profile-overview-bio-excerpt mb-0">No bio yet.</p>
                )
            ) : (
                <textarea
                    className="form-control bio-textarea px-2"
                    aria-label="Edit bio"
                    value={newBio}
                    onChange={(e) => {setNewBio(e.target.value)}}
                />
            )}
        </>
    )
}